/*
 * types/services/dr2am.locales.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {PbPaginate} from './PbPaginate';

/**
 * The ServiceListLocaleNameSpacesRequest model module.
 * @module model/ServiceListLocaleNameSpacesRequest
 * @version version not set
 */
export class ServiceListLocaleNameSpacesRequest {
  /**
   * Constructs a new <code>ServiceListLocaleNameSpacesRequest</code>.
   * @alias module:model/ServiceListLocaleNameSpacesRequest
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceListLocaleNameSpacesRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceListLocaleNameSpacesRequest} obj Optional instance to populate.
   * @return {module:model/ServiceListLocaleNameSpacesRequest} The populated <code>ServiceListLocaleNameSpacesRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceListLocaleNameSpacesRequest();
      if (data.hasOwnProperty('query'))
        obj.query = ApiClient.convertToType(data['query'], 'String');
      if (data.hasOwnProperty('paginate'))
        obj.paginate = PbPaginate.constructFromObject(data['paginate']);
    }
    return obj;
  }
}

/**
 * @member {String} query
 */
ServiceListLocaleNameSpacesRequest.prototype.query = undefined;

/**
 * @member {module:model/PbPaginate} paginate
 */
ServiceListLocaleNameSpacesRequest.prototype.paginate = undefined;


